export default {
    methods: {
        // Determine if a object is related to anything other than an association
        hasNonAssociationRelations: function (relations) {
            // Associations can only be parents so if you have children then
            // you have non associaiton relations
            if (typeof relations.child !== 'undefined' && !(Array.isArray(relations.child) && relations.child.length == 0)) {
                return true
            }

            // Look for relations that are not of type association
            if (typeof relations.parent !== 'undefined' && !(Array.isArray(relations.parent) && relations.parent.length == 0)) {
                for (var type in relations.parent) {
                    if (type != 'assocation') {
                        return true
                    }
                }
            }

            return false
        },

        // If in hiearchy return the closest child's index
        closestChildIndex: function (object) {
            var children = object.relation_count.child

            if (children) {
                switch (object._index) {
                    case 'archival_collection':
                        if (children.archival_series) {
                            indices = 'archival_series'
                        } else if (children.archival_fileunit) {
                            indices = 'archival_fileunit'
                        } else if (children.archival_item) {
                            indices = 'archival_item'
                        }
                        break
                    case 'archival_series':
                        if (children.archival_fileunit) {
                            indices = 'archival_fileunit'
                        } else if (children.archival_item) {
                            indices = 'archival_item'
                        }
                        break
                    case 'archival_fileunit':
                        if (children.archival_item) {
                            indices = 'archival_item'
                        }
                        break
                    default:
                        var indices = false
                }
            }

            return indices
        }
    }
}
